import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { STYLES, TEXTS } from '../../consts/consts';
import Icon from '../../../../../generic-components/Icon';
import EyeIcon from '../../../../../assets/icons/svg/shared/ic-shared-eye-opened.svg';
import CheckDetailsIcon from '../../../../../assets/svg/creation-check-details.svg';
import BankDetailsIcon from '../../../../../assets/svg/creation-bank-details.svg';
import Heading from '../../../../../generic-components/Heading';
import ToggleButton from '../../../InvoiceOnboarding/components/ToggleButton';
import { useStore } from '../../../../../store';
import { CreationContext } from '../../InvoiceCreation';

const { INVOICE_CREATION: { INVOICE_PAYMENT_DETAILS: componentStyles } } = STYLES;

const { INVOICE_CREATION: { INVOICE_PAYMENTS: componentTexts } } = TEXTS;

export const Payments = () => {
  const context = useContext(CreationContext);
  const invoiceData = useStore(state => state.invoiceData);
  const setInvoiceDataToUpdate = useStore(state => state.setInvoiceDataToUpdate);
  const [checkDetailsStatus, setCheckDetailsStatus] = useState<boolean>(invoiceData?.invoicePaymentTerm.checkDepositPaymentMethod || false);
  const [bankDetailsStatus, setBankDetailsStatus] = useState<boolean>(invoiceData?.invoicePaymentTerm.achPaymentMethod || false);
  const { t } = useTranslation();

  useEffect(() => {
    if (invoiceData) {
      const invoiceDataToUpdate = JSON.parse(JSON.stringify(invoiceData));
      invoiceDataToUpdate.invoicePaymentTerm.achPaymentMethod = bankDetailsStatus || 'FALSE';
      invoiceDataToUpdate.invoicePaymentTerm.checkDepositPaymentMethod = checkDetailsStatus || 'FALSE';
      setInvoiceDataToUpdate(invoiceDataToUpdate);
    }
  }, [checkDetailsStatus, bankDetailsStatus]);

  return (
    <div className='basis-1/2'>
      <div className={componentStyles.WRAPPER}>
        <div className={componentStyles.HEADER_WRAPPER}>
          <Icon src={EyeIcon} />
          <Heading title={t(componentTexts.MAIN_TITLE)} className={componentStyles.HEADER} />
        </div>
        <Heading
          title={t(componentTexts.DISCLAIMER)}
          className={componentStyles.DISCLAIMER}
        />
        <div className={componentStyles.ACTIONS_WRAPPER}>
          <div className={componentStyles.TOP_ACTIONS}>
            <div className={componentStyles.TOP_ACTIONS_COUNTER_TITLE_WRAPPER}>
              <Icon src={CheckDetailsIcon} />
              <Heading title={t(componentTexts.CHECK_TOGGLE_LABEL)} className={componentStyles.TOGGLE_HEADER} />
            </div>
            <ToggleButton disabled={context.isLoading} toggleState={checkDetailsStatus} toggle={() => setCheckDetailsStatus(prevState => !prevState)} buttonId='elToggleCheckDetails' />
          </div>

          <div className='w-full flex items-center justify-between'>
            <div className={componentStyles.TOP_ACTIONS_COUNTER_TITLE_WRAPPER}>
              <Icon src={BankDetailsIcon} />
              <Heading title={t(componentTexts.BANK_TOGGLE_LABEL)} className={componentStyles.TOGGLE_HEADER} />
            </div>
            <ToggleButton disabled={context.isLoading} toggleState={bankDetailsStatus} toggle={() => setBankDetailsStatus(prevState => !prevState)} buttonId='elToggleBankDetails' />
          </div>

        </div>
      </div>
    </div>
  );
};
